import { Theme } from "@mui/material/styles";

export const shortWalletAdressDisplayStyles = (
  isDark: boolean,
  theme: Theme
) => ({
  shortWalletBox: {
    display: "flex",
    alignItems: "center",
    pl: 0.3,
    cursor: "pointer"
  },
  shortWallet: {
    fontVariationSettings: "'wght' 500",
    color: theme.palette.primary.main
  },
  arrowIcon: {
    "&:hover": {
      transform: "rotate( -180deg )",
      transition: "transform 150ms ease"
    }
  },
  academyLink: { textDecoration: "none" }
});
